export const YOGA_INTENATIONAL_PATH_PREFIX = 'yoga-international'
